export const PARENT_SLUGS = { CATEGORIES: 'categories', RESOURCES: 'resources'}
export type ParentSlug = typeof PARENT_SLUGS[keyof typeof PARENT_SLUGS]
export const ITEMS_PER_PAGE = 15;
